import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { Keyboard } from '@capacitor/keyboard';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'web', 'android', 'ios'

export async function initCapacitor() {
  if (!isNative) return;

  try {
    // Dark status bar
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#09090b' });
  } catch (e) {
    console.log('StatusBar not available');
  }

  try {
    // Hide splash screen after app is ready
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch (e) {
    console.log('SplashScreen not available');
  }

  try {
    // Handle back button on Android
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch (e) {
    console.log('App listener not available');
  }

  try {
    // Handle keyboard behavior
    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-open');
    });
  } catch (e) {
    console.log('Keyboard listener not available');
  }
}
